export default {
    common: {
        title: 'Inteligência de Conteúdo',
        socialPlanner: 'Planeador Social',
        blog: 'Blogue',
        funnel: 'Funil',
        website: 'Site da internet',
        email: 'Email',
        words: 'Palavras',
        variations: 'Variações',
    },
};
